import { HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, mergeMap } from 'rxjs/operators';
import { AuthService } from './auth.service';
import { environment } from 'src/environments/environment';
import { Location } from '@angular/common';
import { Helpers } from '../helpers/helpers';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AuthInterceptorService {

  constructor(private authorize: AuthService,
    location: Location,
    private router: Router,
    private helpers: Helpers) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    let useSSO = environment.useSSO;

    if (!useSSO)
      return next.handle(req);

    return this.authorize.getAccessToken()
      .pipe(mergeMap(token => this.processRequestWithToken(token ?? "", req, next)));
  }

  // Checks if there is an access_token available in the authorize service
  // and adds it to the request in case it's targeted at the same origin as the
  // single page application.
  private processRequestWithToken(token: string, req: HttpRequest<any>, next: HttpHandler) {    
    if (!!token && (this.helpers.isSameOriginUrl(req) || this.helpers.isApiUrl(req))) {
      req = req.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`
        }
      });
    }

    return next.handle(req).pipe(
      catchError((err: HttpErrorResponse) => {
        if (err.status === 401) {
          this.authorize.getInAuthProcess().subscribe(isInAuthProcess => {
            if (!isInAuthProcess) {
              localStorage['_STIHL_PT_redirectUrl'] = location.pathname;
              this.authorize.setInAuthProcess(true);
              this.authorize.startAuthentication();
            }
          });
        } else if(err.status === 403){
          this.router.navigateByUrl("/forbidden");
        }
        return throwError(err);
      })
    );
  }

  
}
